module.exports = __webpack_public_path__ + "img/slide-6.341f2034.png";